import { initialState } from './reducer';

export interface IBillingStore {}

export function getInitialBillingStore(): IBillingStore {
  return { ...initialState };
}
